export default "__VITE_ASSET__OncqAp1z__"